let local = true;
// let local = false;
let env = "dev";
// let env = 'qa'
// let env = 'prod'

let environment = local ? `local_${env}` : env;
export default environment;
